import React from 'react';
import { Flex } from '@gjensidige/builders-components';

import styles from '../../style.scss';

interface IllustrationSectionProps {
  imageUrl: string;
  imageAltText?: string;
  smallScreenImage?: string;
}

export const IllustrationSection: React.FC<IllustrationSectionProps> = (
  props: IllustrationSectionProps
) => {
  return (
    <Flex className={styles.imageSection}>
      {props.smallScreenImage ? (
        <picture>
          <source media="(max-width: 799px)" srcSet={props.smallScreenImage} />
          <source media="(min-width: 800px)" srcSet={props.imageUrl} />
          <img src={props.imageUrl} alt={props.imageAltText || ''} />
        </picture>
      ) : (
        <img src={props.imageUrl} alt={props.imageAltText || ''} />
      )}
    </Flex>
  );
};
